import React, { useEffect, useState } from "react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { Form, Row, Col } from "react-bootstrap";
import noimage from "../../assets/img/noimage.png";
import { useLocation, useNavigate } from "react-router-dom";
import { AssetStatusChange, formStatusUpdate } from "../../Actions/axios";
import { toast } from "react-toastify";
import Modal from "react-modal";
import Urlmodals from "../../Modals/Urlmodal";
import config from "../../config/config";
const ViewForm = () => {
  const location = useLocation();
  const [data, setData] = useState({});
  const [aprroveStatus, setApproveStatus] = useState(false);
  const [rejectStatus, setRejectStatus] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [urlmod, setUrlmod] = useState(false);
  const [urlData, setUrlData] = useState({});


  const navigate = useNavigate();
  console.log("locationssss", location);
  const { records, sectionType } = location?.state;
  console.log("YTTTTTTTTTTTTT", aprroveStatus, rejectStatus);
  useEffect(() => {
    setData(location?.state);
    if (records?.status == "approved") {
      setApproveStatus(true);
    } else if (records?.status == "rejected") {
      setRejectStatus(true);
      setRejectReason(records?.rejectedreason);
    } else {
      setApproveStatus(false);
      setRejectStatus(false);
    }
  }, [location]);
  const isAnswered = (answer) => {
    if (typeof answer === "string") return answer.trim() !== "";
    if (typeof answer === "boolean") return answer === true;
    if (Array.isArray(answer)) {
      return answer.some(
        (item) =>
          (typeof item === "string" && item.trim() !== "") ||
          (typeof item === "boolean" && item === true) ||
          (typeof item === "object" &&
            item !== null &&
            Object.values(item).some(
              (v) =>
                (typeof v === "string" && v.trim() !== "") ||
                (typeof v === "boolean" && v === true)
            ))
      );
    }
    if (typeof answer === "object" && answer !== null) {
      return Object.values(answer).some(
        (v) =>
          (typeof v === "string" && v.trim() !== "") ||
          (typeof v === "boolean" && v === true)
      );
    }
    return false;
  };

  const changeStatus = async (checked, status) => {
    try {
      if (status !== "submit") {
        if (status === "approved") {
          setApproveStatus(checked);
          setRejectStatus(false);
        } else if (status === "rejected") {
          setApproveStatus(false);
          setRejectStatus(checked);
        }
      } else {
        const resp = await formStatusUpdate({
          formId: records?._id,
          status: aprroveStatus ? "approved" : "rejected",
          rejectreason: aprroveStatus ? "" : rejectReason,
          ...urlData
        });
        console.log('resp-->',resp)
        if (resp.status) {
          toast.success(resp?.message);
          navigate("/ViewFormLists");
        } else {
          toast.success(resp?.message);
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  };

   const onChangeFunc = (e) => {
    const { name, value } = e.target;
    setUrlData({ ...urlData, [name]: value });
  };

  return (
    <>
      {urlmod && (
        <Urlmodals
          onDismiss={() => {setUrlmod(false);setApproveStatus(false)}}
          urlmod={urlmod}
          data={data}
          onChangeFunc={(e) => onChangeFunc(e)}
          onSummitFunc={() => changeStatus(true, "submit")}
        />
      )}

      <div className="cmsedit">
        <button
          className="btn sitebtn mb-4"
          onClick={() =>
            navigate("/ViewFormLists", {
              state: { goBackSectionType: sectionType },
            })
          }
        >
          Back
        </button>
        <h1 className="pagehead">Form Details</h1>
        <div className="cardbox formlistuser">
          {records?.fields &&
            Object.entries(records?.fields).map(
              ([sectionName, questions], i) => {
                console.log(
                  "location?.state?.ques?.find(val=>val.stepName == sectionName)",
                  sectionName,
                  "jjjjjjjj",
                  questions
                );
                let sectionScore = 0;
                let sectionTotal = 0;
                return (
                  <React.Fragment key={i}>
                    <tr>
                      <td className="fw-600">
                        <h5 className="mt-3 mb-4 mainheading">
                          {i + 1 + ". " + sectionName}
                        </h5>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>

                    {Object.entries(questions).map(
                      ([question, answerArray], j) => {
                        console.log(
                          "hhhhhhhhhh",
                          question,
                          "adffffffffffffffffffff",
                          answerArray
                        );
                        const isMainAnswered = answerArray?.includes(".webp");

                        console.log(
                          "WebP Images:",
                          isMainAnswered,
                          `${config.Back_URL}${answerArray}`
                        );

                        if (
                          !location?.state?.ques
                            ?.find((val) => val.stepName == sectionName)
                            ?.inputs?.find((val) => val.subheading == question)
                        ) {
                          sectionTotal++;
                        }
                        if (
                          isAnswered(answerArray) &&
                          !location?.state?.ques
                            ?.find((val) => val.stepName == sectionName)
                            ?.inputs?.find((val) => val.subheading == question)
                        )
                          sectionScore++;
                        return (
                          <React.Fragment key={j}>
                            <tr>
                              <td className="fw-600">{`${question}`}</td>
                              <td className="text-center px-2"></td>

                              <Col className="mb-4">
                                {!isMainAnswered ? (
                                  !(
                                    Array.isArray(answerArray) &&
                                    answerArray.every(
                                      (item) =>
                                        typeof item === "object" &&
                                        item !== null &&
                                        !Array.isArray(item)
                                    )
                                  ) && (
                                    <Form.Group>
                                      {Array.isArray(answerArray) ? (
                                        answerArray.map((item, idx) => (
                                          <Form.Control
                                            key={idx}
                                            type="text"
                                            value={
                                              isAnswered(answerArray)
                                                ? typeof item === "string" &&
                                                  item.includes("T") &&
                                                  !isNaN(Date.parse(item))
                                                  ? item.split("T")[0]
                                                  : typeof item === "object"
                                                  ? ""
                                                  : String(item)
                                                : "null"
                                            }
                                            disabled={true}
                                            className="mb-2"
                                          />
                                        ))
                                      ) : (
                                        <Form.Control
                                          type="text"
                                          value={
                                            location?.state?.ques
                                              ?.find(
                                                (val) =>
                                                  val.stepName === sectionName
                                              )
                                              ?.inputs?.find(
                                                (val) =>
                                                  val.subheading === question
                                              )
                                              ? ""
                                              : isAnswered(answerArray)
                                              ? typeof answerArray === "string"
                                                ? answerArray.includes("T") &&
                                                  !isNaN(
                                                    Date.parse(answerArray)
                                                  )
                                                  ? answerArray.split("T")[0]
                                                  : answerArray
                                                : typeof answerArray ===
                                                  "object"
                                                ? answerArray
                                                : String(answerArray)
                                              : "null"
                                          }
                                          disabled={true}
                                        />
                                      )}
                                    </Form.Group>
                                  )
                                ) : (
                                  <Form.Group>
                                    {Array.isArray(answerArray) ? (
                                      answerArray.map((item, idx) =>
                                        typeof item === "string" &&
                                        item.endsWith(".webp") ? (
                                          <img
                                            key={idx}
                                            src={`${config.Back_URL}formImage/${item}`}
                                            alt={`Uploaded-${idx}`}
                                            className="imgset"
                                          />
                                        ) : (
                                          <div key={idx}>{String(item)}</div>
                                        )
                                      )
                                    ) : typeof answerArray === "string" &&
                                      answerArray.endsWith(".webp") ? (
                                      <img
                                        src={`${config.Back_URL}formImage/${answerArray}`}
                                        alt="Uploaded"
                                        className="imgset"
                                      />
                                    ) : (
                                      <div>{String(answerArray)}</div>
                                    )}
                                  </Form.Group>
                                )}
                              </Col>
                            </tr>
                            {Array.isArray(answerArray) &&
                              answerArray.map((answerGroup, k) =>
                                typeof answerGroup === "object" &&
                                !Array.isArray(answerGroup)
                                  ? Object.entries(answerGroup).map(
                                      ([param, value], l) => {
                                        if (isAnswered(value)) sectionScore++;
                                        console.log(
                                          "sub_inputes",
                                          param,
                                          value
                                        );
                                        const isSubAnswered = isAnswered(value);
                                        sectionTotal++;
                                        return (
                                          <tr key={`${j}-${k}-${l}`}>
                                            {console.log(
                                              "location?.state?.ques?.find(val=>val.stepName == sectionName).subinputs?.find(val=>val.subheading == param)",
                                              location?.state?.ques
                                                ?.find(
                                                  (val) =>
                                                    val.stepName == sectionName
                                                )
                                                .inputs?.find(
                                                  (val) =>
                                                    val.subheading == question
                                                )
                                                .subinputs?.find(
                                                  (val) => val.name == param
                                                )
                                            )}
                                            <td>{param}</td>
                                            <td className="text-center px-2"></td>
                                            <Col
                                              xs={12}
                                              sm={12}
                                              md={6}
                                              lg={6}
                                              xl={4}
                                              xxl={4}
                                              className="mb-4"
                                            >
                                              <Form.Group>
                                                <Form.Control
                                                  type="text"
                                                  value={
                                                    isAnswered(value)
                                                      ? value
                                                      : "null"
                                                  }
                                                  disabled={true}
                                                />
                                              </Form.Group>
                                            </Col>
                                          </tr>
                                        );
                                      }
                                    )
                                  : null
                              )}
                          </React.Fragment>
                        );
                      }
                    )}
                  </React.Fragment>
                );
              }
            )}
          <div className="d-flex gap-4 mt-3 mb-4 checks">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                checked={aprroveStatus}
                onChange={(e) => {
                  if (sectionType == "exchange") {
                    setApproveStatus(e.target.checked);
                    setRejectStatus(false);
                    setUrlmod(true);
                  } else {
                    changeStatus(e.target.checked, "approved");
                  }
                }}
              />
              <label class="form-check-label" for="flexCheckDefault">
                Approve
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                checked={rejectStatus}
                onChange={(e) => changeStatus(e.target.checked, "rejected")}
              />
              <label class="form-check-label" for="flexCheckDefault">
                Reject
              </label>
            </div>
          </div>

          <div>
            {rejectStatus && (
              <textarea
                type="text"
                className="form-control w-100 mt-3"
                rows={4}
                value={rejectReason}
                onChange={(e) => setRejectReason(e.target.value)}
              />
            )}
          </div>
          {aprroveStatus || rejectStatus ? (
            <button
              className="btn sitebtn mt-4"
              onClick={() => changeStatus("", "submit")}
            >
              Submit
            </button>
          ) : (
            <button
              className="btn sitebtn mt-4"
              disabled
              onClick={() => changeStatus("", "submit")}
            >
              Submit
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewForm;
